/** The clause that attributes an entry to the data job that wrote it. */
export const importSuffix = dataJobId =>
  dataJobId ? ` via import (Data Job #${dataJobId})` : "";
